/* eslint-disable no-unused-vars */

import { Edit } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { GridColumns } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, DataTable } from '../../components';
import MainContainer from '../../components/MainContainer';
import { usePersonContext } from '../../contexts/PersonContext';
import { Person } from '../../entities';
import { useFetch, usePersons } from '../../hooks';
import useStyles from './styles';

interface UpdateButtonProps {
  value: Person;
}

const UpdateButton = ({ value }: UpdateButtonProps): JSX.Element => {
  const { handleSelectPerson } = usePersonContext();
  return (
    <IconButton onClick={() => handleSelectPerson(value)}>
      <Edit />
    </IconButton>
  );
};

const headers: GridColumns = [
  {
    field: 'photoUrl',
    headerName: '',
    disableColumnMenu: true,
    editable: false,
    disableExport: true,
    disableReorder: true,
    hideable: false,
    filterable: false,
    sortable: false,
    width: 62,
    align: 'center',
    hideSortIcons: true,
    renderCell: (value) => <Avatar src={value.row.photoUrl} />,
  },
  { field: 'name', headerName: 'Nome', editable: false, flex: 1 },
  { field: 'email', headerName: 'Email', editable: false, flex: 2 },
  {
    field: 'action',
    headerName: 'Ações',
    disableColumnMenu: true,
    editable: false,
    disableExport: true,
    disableReorder: true,
    hideable: false,
    filterable: false,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    renderCell: (value) => <UpdateButton value={value.row} />,
    hideSortIcons: true,
  },
];

export const Persons = (): JSX.Element => {
  const [persons, setPersons] = useState<Person[]>();
  const repository = usePersons();
  const { data, loading } = useFetch(repository.fetchAll);
  const styles = useStyles();
  const navigate = useNavigate();

  useEffect(() => {
    setPersons(data?.filter(person => !person.isDisabled));
  }, [data]);
  return (
    <MainContainer>
      <div className={styles.content}>
        <DataTable
          columns={headers}
          rows={persons || []}
          loading={loading}
          showAddButton
          onClickAdd={() => navigate('/persons/new')}
        />
      </div>
    </MainContainer>
  );
};

export default Persons;
